/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsigneeToursArrayV3 } from '../../models/consignee-tours-array-v-3';
import { ConsigneeToursFilterProperties } from '../../models/consignee-tours-filter-properties';
import { KeyType } from '../../models/key-type';
import { SortType } from '../../models/sort-type';

export interface GetConsigneeToursV3$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * Array of organization site keys to fetch data from (max 10). If provided, overrides the path parameter.
 */
  organizationSiteKeys?: Array<KeyType>;

/**
 * Maximum number of items to return
 */
  limit?: number;

/**
 * Number of items to skip
 */
  offset?: number;

/**
 * Sort direction (asc or desc)
 */
  sort?: SortType;

/**
 * Field to sort by for tours
 */
  sortBy?: 'dateCreated' | 'dateClosed' | 'checkoutDate' | 'tourNumber' | 'externalTourName' | 'status' | 'consignorName' | 'consigneeName' | 'carrierName';

/**
 * Field to filter consignee tours by
 */
  filterProperty?: ConsigneeToursFilterProperties;

/**
 * Value to filter by (partial match)
 */
  filterValue?: string;

/**
 * Filter for not closed items only (bundles, tours, delivery notes)
 */
  filterNotClosed?: boolean;
}

export function getConsigneeToursV3(http: HttpClient, rootUrl: string, params: GetConsigneeToursV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeToursArrayV3>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeToursV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('organizationSiteKeys', params.organizationSiteKeys, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sort', params.sort, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('filterProperty', params.filterProperty, {});
    rb.query('filterValue', params.filterValue, {});
    rb.query('filterNotClosed', params.filterNotClosed, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsigneeToursArrayV3>;
    })
  );
}

getConsigneeToursV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/tours';
